/** Keep the HTML and React loaders on one clock, including UI selection. */
export function bootSplashDelays(now = performance.now()) {
  const page = document.documentElement;
  const recorded = page.getAttribute('data-borrah-boot-start');
  const start = recorded === null ? now : Number(recorded);
  if (recorded === null) page.setAttribute('data-borrah-boot-start', `${now}`);
  // UI selection may finish long after navigation. Fade in once when the
  // selected loader first appears, then continue through every boot gate.
  const elapsed = Math.max(0, now - start);
  return {
    fade: `${-Math.round(elapsed)}ms`,
    slide: `${-Math.round(elapsed % 1400)}ms`,
  };
}

export function syncBootSplashTimeline(root: ParentNode) {
  const delays = bootSplashDelays();
  for (const splash of root.querySelectorAll<HTMLElement>('.borrah-boot')) {
    splash.style.animationDelay = delays.fade;
  }
  for (const bar of root.querySelectorAll<HTMLElement>('.borrah-boot__bar')) {
    bar.style.animationDelay = delays.slide;
  }
}
